// BroadcastsLayout — chrome for /admin/broadcasts (PLEX-4102).
//
// Gated on userStore.isAdmin (Plex employee — @plexresearch.com OR the `admins`
// Cognito group). Soft gate (render a message) rather than redirect, so an
// admin who shares the URL gets a sensible page. Mirrors SkuCatalogLayout.

import { inject, observer } from "mobx-react";
import { Outlet } from "react-router-dom";

import { withAuthentication } from "../../components/AuthenticateUser";
import "../admin-entitlements/AdminEntitlements.css"; // reuse the page chrome
import "./AdminBroadcasts.css";

const BroadcastsLayout = ({ userStore }) => {
  if (!userStore.isAdmin) {
    return (
      <div className="adminEnt stone-page">
        <div className="gate">
          <h2>Administrators only</h2>
          <p>
            This area manages system broadcasts — the banner shown to every user
            of this cell. Only Plex administrators can raise or lower them.
          </p>
          <p className="adminBc-gate-note">
            If you need access, ask a Plex admin to add you to the
            <strong> admins </strong> Cognito group.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="adminEnt stone-page">
      <div className="adminEnt-shell adminBc-shell">
        <main className="adminEnt-page">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default withAuthentication(inject("userStore")(observer(BroadcastsLayout)));
